import React, { createContext, useContext } from 'react';

type InputConfigurationProviderContextType = {
  deferWrapper?: {
    enabled?: boolean;
  };
};

const InputConfigurationProviderContext =
  createContext<InputConfigurationProviderContextType>({});

export function InputConfigurationProvider(
  props: React.PropsWithChildren<InputConfigurationProviderContextType>,
) {
  const { children, ...value } = props;

  return (
    <InputConfigurationProviderContext.Provider value={value}>
      {children}
    </InputConfigurationProviderContext.Provider>
  );
}

export function useInputConfigurationProviderContext() {
  const context = useContext(InputConfigurationProviderContext);
  return context;
}
